import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SINGLE_OFFICE_MODE } from '../../config';
import BtnSideBar from '../../common/BtnSideBar/BtnSideBar';
import SeparatorSideBar from '../../common/SeparatorSideBar/SeparatorSideBar';

import { StyledSideBar } from './styles/StyledSideBar';


class SideBar extends Component {
  render() {
    const { activePage, officeId, serviceId, intervalId, titleOne, titleTwo, titleThree, titleFour, } = this.props;
    
    return (
      <StyledSideBar>
        <ul>
          { !SINGLE_OFFICE_MODE && 
            <li className="sidebar-button"  aria-current={activePage === 0 ? "page": false}>
              <BtnSideBar 
                text={titleOne}  
                isActive={activePage === 0}
                enableClick={activePage === 1 || activePage === 2 || activePage === 3}
                position={1}
                linkTo="/"
                icon="map"
              />
            </li>        
          }
          { !SINGLE_OFFICE_MODE &&
            <li className="sidebar-separator">
              <SeparatorSideBar />
            </li>
          }
          <li className="sidebar-button" aria-current={activePage === 1 ? "page": false}>
            <BtnSideBar 
              text={titleTwo} 
              isActive={activePage === 1}
              enableClick={activePage === 2 || activePage === 3}
              position={SINGLE_OFFICE_MODE ? 1 : 2}
              linkTo={SINGLE_OFFICE_MODE ? '/' : '/office/' + officeId}
              icon="list"
            />
          </li>
          <li className="sidebar-separator">
            <SeparatorSideBar />
          </li>
          <li className="sidebar-button" aria-current={activePage === 2 ? "page": false}>
            <BtnSideBar 
              text={titleThree}
              isActive={activePage === 2}
              enableClick={activePage === 3}
              position={SINGLE_OFFICE_MODE ? 2 : 3}
              linkTo={'/office/' + officeId + '/service/' + serviceId}
              icon="clock-o"
            />
          </li>
          <li className="sidebar-separator">
            <SeparatorSideBar />
          </li>
          <li className="sidebar-button" aria-current={activePage === 3 ? "page": false}>
            <BtnSideBar 
              text={titleFour}
              isActive={activePage === 3}
              enableClick={false}
              position={SINGLE_OFFICE_MODE ? 3 : 4}
              linkTo={'/office/' + officeId + '/service/' + serviceId + '/interval/' + intervalId}
              icon="check-square-o"
            />
          </li>
        </ul>
      </StyledSideBar>
    );
  }
}


SideBar.propTypes = {
  activePage: PropTypes.number.isRequired,
  officeId: PropTypes.string.isRequired,
  serviceId: PropTypes.string.isRequired,
  intervalId: PropTypes.string.isRequired,
  titleOne: PropTypes.string,
  titleTwo: PropTypes.string,
  titleThree: PropTypes.string,
  titleFour: PropTypes.string,
};


export default SideBar;